































import {
  Component,
  Inject,
  Prop,
  Vue
} from 'vue-property-decorator';
import { ConfigService } from '@/services/ConfigService';
import { EssenceItemDto } from '../../../../../../hub-client-typescript/target/generated-client';
import MatomoEvents from '@/matomo/events/MatomoEvents';
import MatomoContext from '@/matomo/domain/MatomoContext';

@Component({})
export default class EssenceDropdown extends Vue {
  public opened = false;

  @Prop({ required: true })
  public essenceList: EssenceItemDto[];

  @Prop({ required: false, default: false })
  public highlighted: boolean;

  @Inject({ default: MatomoContext.default() })
  public matomoContext: MatomoContext;

  public toggleEssenceList() {
    MatomoEvents.forEssences.toggleDropdown.publishWithContext(this.matomoContext);
    this.opened = !this.opened;
  }

  private formatDate(date: string) {
    const priceDate = new Date(date);
    return priceDate.toLocaleDateString('de-AT');
  }
}
